import { createContext } from 'react';

import { DEFAULT_SETTINGS } from '../../constants';
import { DiceReceiverManager } from '../../services';

import type { ReceiverContextValue } from './types/ReceiverContextValue';

export const ReceiverContext = createContext<ReceiverContextValue>({
    settings: DiceReceiverManager.getInstance().getSettings() ?? DEFAULT_SETTINGS
});
